import Fuse, { type IFuseOptions } from 'fuse.js'

export function filterStructuredDocument<T>(items: T[], filterText: string, fuseOptions: IFuseOptions<T>): T[] {
  if (!filterText) {
    return items
  }

  return new Fuse(items, fuseOptions).search(filterText).map((result) => result.item)
}
